module.exports = __webpack_public_path__ + "static/ARIALBDBOLD-4043d33b76946371e1c043487c51c104.otf";